import React, { createContext, useState, useContext, useEffect } from 'react';
import authService from '../services/AuthService';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true); // Inicia en true

    useEffect(() => {
        const tokenData = authService.getCurrentToken();
        if (tokenData) {
            setUser({ token: tokenData.access_token });
        }
        setLoading(false); // Termina de cargar después de revisar el token
    }, []);

    const login = async (username, password) => {
        const tokenData = await authService.login(username, password);
        setUser({ token: tokenData.access_token });
        return tokenData;
    };

    const logout = () => {
        authService.logout();
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};